import React from "react";
import { PageLayout } from "components/layout/PageLayout";
import ExperienceAccordion from "containers/experienceAccordion/ExperienceAccordion";
import PageHero from "components/pageHero/PageHero";
import { experience } from "portfolio";
import ExperienceImg from "./ExperienceImg";
import type { Theme } from "types";

interface ExperienceProps {
  theme: Theme;
  setTheme: React.Dispatch<React.SetStateAction<string>>;
}

function Experience({
  theme,
  setTheme,
}: Readonly<ExperienceProps>): React.ReactElement {
  return (
    <PageLayout theme={theme} setTheme={setTheme}>
      <PageHero
        eyebrow="Career Story"
        title={experience.title || "Experience"}
        subtitle={experience.subtitle}
        description={experience.description || ""}
        highlights={[
          "Engineering leadership",
          "Platform thinking",
          "Scalable backend systems",
        ]}
        media={<ExperienceImg theme={theme} />}
      />
      <ExperienceAccordion sections={experience.sections || []} />
    </PageLayout>
  );
}

export default Experience;
